const configBoardTemplate = {
    memberQa: {
        filterLayout: 'BoardFilterNoneLayout',
        listLayout: 'BoardMemberQaListLayout',
        paginationLayout: 'PaginationDefaultLayout',
    },
    faq: {
        filterLayout: 'BoardFaqFilterLayout',
        listLayout: 'BoardFaqListLayout',
        paginationLayout: 'PaginationDeleteLayout',
    },
    writeFaq: {
        writeLayouts: ['BoardWriteFaqLayout'],
    },
    updateFaq: {
        writeLayouts: ['BoardWriteFaqLayout'],
    },
    qa: {
        filterLayout: 'BoardQaFilterLayout',
        listLayout: 'BoardQaListLayout',
        paginationLayout: 'PaginationDeleteLayout',
    },
    writeQa: {
        writeLayouts: ['BoardWriteQaLayout'],
    },
    updateQa: {
        writeLayouts: ['BoardWriteQaLayout'],
    },
    notice: {
        filterLayout: 'BoardNoticeFilterLayout',
        listLayout: 'BoardNoticeListLayout',
        paginationLayout: 'PaginationDeleteLayout',
    },
    writeNotice: {
        writeLayouts: ['BoardWriteNoticeLayout'],
    },
    updateNotice: {
        writeLayouts: ['BoardWriteNoticeLayout'],
    },
}

export default {
    methods: {
        returnBoardTemplateConfig(type) {
            return configBoardTemplate[type];
        }
    },
}
